import "@/App.css";
import Experience from "@/Experience";

function App() {
  return <Experience />;
}

export default App;
